import * as React from 'react';
import Paper from '@mui/material/Paper';
import { Box, CircularProgress, LinearProgress, Stack, Typography } from '@mui/material';
import Zoom from '@mui/material/Zoom';
import { green, blueGrey, blue, red } from '@mui/material/colors';
import { repeatEffect, settingsConfig, toFormatedDateMinHour } from 'utils/commonFunc';
import ApiService from 'services/ApiService';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import defColors from 'utils/defColors';

const ProcessDataBox = ({ item, styleColor, sx }) => {
    const iconDef = {
        sx: {
            transform: 'scale(1.5)'
        }
    }

    const isPositive = () => {
        return (item.diff) >= 0
    }
    return (
        <Paper
            elevation={3}
            sx={{
                p: 2,
                width: 240,
                background: 'var(--white-05)',
                backgroundImage: 'none',
                borderRadius: 3,
            }}>
            <Stack
                direction={'column'}
                justifyContent="center"
                alignItems="center"
                spacing={1}
            >
                <Paper variant="outlined" sx={{ position: 'relative', p: 1, pl: 4, pr: 4, backgroundColor: styleColor, whiteSpace:'nowrap' }}>
                    <Stack direction={'row'}
                        justifyContent="flex-start"
                        alignItems="center" spacing={2}>
                        <SyncAltIcon {...iconDef} />
                        <Typography variant="h5">{item.displayName}</Typography>
                    </Stack>
                </Paper>
                <Stack
                    direction={'row'}
                    justifyContent="center"
                    alignItems="center"
                    spacing={1}>
                    <Typography variant='h5' textAlign={'center'} p={1}>{item.count?.toLocaleString()}건</Typography>
                    <Typography variant='h6' textAlign={'center'} color={isPositive() ? green[300] : red[300]}>
                        ({isPositive() && '+'}{(item.diff)?.toLocaleString()})
                    </Typography>
                </Stack>
            </Stack>
        </Paper>
    )
}

// export const PopupViewDataProcess = () => {
//     const [currentData, setCurrentData] = React.useState()

//     React.useEffect(() => {
//         return repeatEffect(
//             async () => {
//                 const response = await ApiService.get("newdashboard/gis/DataProcess");
//                 if (response.status === 200) {
//                     const data = response.data;
//                     setCurrentData(data)
//                 }
//             },
//             settingsConfig().contentUpdateDelaySec)
//     }, []);

//     return (
//         <div className='popup_dtprcs' style={{ background: 'linear-gradient(136deg,rgb(2 6 20)  0%, rgb(28 28 35) 68%)', overflow: 'hidden', color: 'white', width: '1680px', height: '780px', borderRadius: '26px', padding: '40px' }}>
//             {currentData &&
//                 <Stack sx={{ height: '100%', width: '100%' }}
//                     direction="column"
//                     justifyContent="space-between"
//                     alignItems="center"
//                     spacing={2}>
//                     <Stack
//                         direction="row"
//                         justifyContent="center"
//                         alignItems="stretch"
//                         spacing={3}>
//                         {
//                             currentData?.group1?.map(p => <ProcessDataBox key={p.procType} styleColor={defColors.serverStatus[0]} item={p} />)
//                         }
//                     </Stack>
//                     <Box sx={{ width: '85%' }}>
//                         <LinearProgress />
//                         {/* <Box sx={{
//                             position: 'absolute',
//                             width: '100%',
//                             top: '0',
//                             display: 'flex',
//                             justifyContent: 'space-between'
//                         }}>
//                             {currentData?.group1?.map((_, index) => {
//                                 const leftPositions = [-2, 280, 560, 810, 1090, 1358]; // 각 선의 left 위치 (px)
//                                 return (
//                                     <Box
//                                         key={index}
//                                         sx={{
//                                             width: '1px',
//                                             height: '60px',
//                                             backgroundColor: 'primary.main',
//                                             position: 'absolute', // absolute로 변경
//                                             top: '180px', // transform 대신 top 사용
//                                             left: `${leftPositions[index]}px` // marginLeft → left로 변경
//                                         }}
//                                     />
//                                 );
//                             })}
//                         </Box> */}
//                         {/* <Box sx={{
//                             position: 'absolute',
//                             width: '100%',
//                             top: '0',
//                             display: 'flex',
//                             justifyContent: 'space-between'
//                         }}>
//                             {currentData?.group1?.map((_, index) => {
//                                 // 7개의 선 위치 (px 단위)
//                                 const leftPositions = [-2, 280, 680, 560, 810, 1090, 1200]; // 7번째 선 추가
//                                 const isTargetLine = index === 2; // 3번째 선(index 2)을 타겟으로 설정 (원하는 인덱스로 변경)

//                                 return (
//                                     <Box
//                                         key={index}
//                                         sx={{
//                                             width: '1px',
//                                             height: '60px',
//                                             backgroundColor: isTargetLine ? 'primary.main' : 'primary.main', // 타겟 선은 빨간색
//                                             position: 'absolute',
//                                             top: '180px',
//                                             left: `${leftPositions[index]}px`,
//                                             // 타겟 선만 추가 스타일링
//                                             ...(isTargetLine && {
//                                                 height: '66px', // 길이 변경
//                                                 width: '2px', // 두께 변경
//                                                 zIndex: 0, // 다른 선 위로 올리기
//                                                 top : '240px',
//                                             })
//                                         }}
//                                     />
//                                 );
//                             })}
//                         </Box> */}
//                         <Box sx={{
//                             position: 'absolute',
//                             width: '100%',
//                             top: '0',
//                         }}>
//                             {Array(7).fill().map((_, index) => {
//                                 const leftPositions = [-2, 280, 680, 560, 810, 1090, 1360];  // 2번 인덱스가 중앙 선임 
//                                 return (
//                                     <Box
//                                         key={index}
//                                         sx={{
//                                             width: '1px',
//                                             height: '60px',
//                                             backgroundColor: index === 6 ? 'primary.main' : 'primary.main',
//                                             position: 'absolute',
//                                             top: '178px',
//                                             left: `${leftPositions[index]}px`,
//                                             ...(index === 2 && {
//                                                 height: '61px',
//                                                 width: '2px',
//                                                 top: '245px',
//                                                 zIndex: 1,
//                                             }),
//                                             ...(index === 6 && {
//                                                 height: '62px',
//                                                 top: '178px',
//                                                 zIndex: 2,
//                                             })
//                                         }}
//                                     />
//                                 );
//                             })}
//                         </Box>
//                     </Box>
//                     <Stack
//                         justifyContent="center"
//                         alignItems="stretch"
//                         spacing={3}>
//                         {
//                             currentData?.group2?.map(p => <ProcessDataBox key={p.procType} styleColor={defColors.serverStatus[1]} item={p} />)
//                         }
//                     </Stack>
//                     <Box sx={{
//                         width: '20%',
//                         position: 'relative', // 부모 컨테이너는 relative 필수
//                     }}>
//                         <LinearProgress />
//                         {[450, 610, 770].map((leftPos, index) => ( // 1번 인덱스가 중앙선임
//                             <Box
//                                 key={index}
//                                 sx={{
//                                     width: '1px',
//                                     height: '60px',
//                                     marginLeft : '-450px',
//                                     backgroundColor: 'primary.main',
//                                     position: 'absolute',
//                                     top: '64px', 
//                                     left: `${leftPos}px`,
//                                     transform: 'translateY(-100%)', // 선을 Progress 바 위로 이동
//                                     ...(index === 1 && { // 1번 인덱스 선 (680px) 스타일
//                                         height: '62px',
//                                         width: '2px',
//                                         top : '2px',
//                                         backgroundColor: 'primary.main', 
//                                     })
//                                 }}
//                             />
//                         ))}
//                     </Box>
//                     <Stack
//                         direction="row"
//                         background="var(--gs-90)"
//                         justifyContent="center"
//                         alignItems="stretch"
//                         spacing={6}>
//                         {
//                             currentData?.group3?.map(p => <ProcessDataBox key={p.procType} styleColor={defColors.serverStatus[2]} item={p} />)
//                         }
//                     </Stack>
//                 </Stack>
//             }
//         </div>
//     )
// }

// 교통정보 수집현황 수정 (수원요청 ) 수정시각 19:53
export const  PopupViewDataProcess = () => {
    const [currentData, setCurrentData] = React.useState()

    React.useEffect(() => {
        return repeatEffect(
            async () => {
                // const response = await ApiService.get("dashboard/DataProcess");
                const response = await ApiService.get("newdashboard/gis/DataProcess");
                if (response.status === 200) {
                    const data = response.data;
                    setCurrentData(data)
                }
            },
            settingsConfig().contentUpdateDelaySec)
    }, []);

    return (
        <div className='popup_dtprcs' style={{ background: 'linear-gradient(136deg,rgb(2 6 20)  0%, rgb(28 28 35) 68%)', overflow: 'hidden', color: 'white', width: '1680px', height: '780px', borderRadius: '26px', padding: '40px' }}>
            {currentData &&
                <Stack sx={{ height: '100%', width: '100%' }}
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    spacing={2}>
                    <Stack
                        justifyContent="center"
                        alignItems="stretch"
                        spacing={3}>
                        {
                            currentData?.group1?.map(p => <ProcessDataBox key={p.procType} styleColor={defColors.serverStatus[0]} item={p} />)
                        }
                    </Stack>
                    <Box sx={{ width: '10%' }}>
                        <LinearProgress />
                    </Box>
                    <Stack
                        justifyContent="center"
                        alignItems="stretch"
                        spacing={6}>
                        {
                            currentData?.group2?.map(p => <ProcessDataBox key={p.procType} styleColor={defColors.serverStatus[1]} item={p} />)
                        }
                    </Stack>
                    <Box sx={{ width: '10%' }}>
                        {/* <LinearProgress sx={{ transform: 'scaleX(-1)' }} /> */}
                        <LinearProgress />
                    </Box>
                    <Stack
                        justifyContent="center"
                        alignItems="stretch"
                        spacing={6}>
                        {
                            currentData?.group3?.map(p => <ProcessDataBox key={p.procType} styleColor={defColors.serverStatus[2]} item={p} />)
                        }
                    </Stack>
                </Stack>
            }
        </div>
    )
}